import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { AppLocale } from '@procsea/common/utils'
import { Card } from '@procsea/design-system'

export const KLARYS_TERMS_OF_USE_URL: Record<AppLocale, string> = {
  [AppLocale.EN]: 'https://www.klarys.io/en/terms-of-service',
  [AppLocale.FR]: 'https://www.klarys.io/conditions-generales-dutilisation',
  [AppLocale.DE]: 'https://www.klarys.io/en/terms-of-service',
  [AppLocale.IT]: 'https://www.klarys.io/en/terms-of-service',
}

export const EMAIL_ALREADY_USED_ERROR = 'Email already exists'
export const INVALID_INPUT_ERROR = 'Invalid input'

export const AuthContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  max-width: 560px;
  min-height: 100vh;
  padding: ${props => props.theme.spacings.medium};
  text-align: center;
  width: 100%;

  & > *:not(:last-child) {
    margin-bottom: ${props => props.theme.spacings.large};
  }
`

export const HeaderLogo = styled.img`
  margin: auto;
  width: 100%;
  max-height: 150px;
`

export const FullwidthCard = styled(Card)`
  text-align: center;
  width: 100%;
`

export const AuthMainCard = styled(FullwidthCard)`
  border-top: 3px solid ${props => props.theme.colors.primary.base};
`
export const AuthMainCardImage = styled.img`
  margin: auto;
  height: 36px;
`

export const StyledRouterLink = styled(Link)`
  text-decoration: underline;
`
